import SiteHeader from '@/shared/ui/SiteHeader';
import { Outlet } from 'react-router';
import { Flex } from '@repo/ui/components';
import useIsTeams from '@/shared/hooks/useTeams';

const HeaderLayout = () => {
  const isTeams = useIsTeams();
  return (
    <>
      {!isTeams && <SiteHeader />}
      <Flex asChild justify='center' align='center' direction='column'>
        <main>
          <Outlet />
        </main>
      </Flex>
    </>
  );
};

export default HeaderLayout;
